// Module
var code = "<i ng-if=\"$ctrl.isPhoneNumberTypeCustom()\" ng-bind=\"$ctrl.ngModel\"></i> <i ng-if=\"!$ctrl.isPhoneNumberTypeCustom()\"> {{ 'Enums.PhoneNumberType.Enum' + $ctrl.ngModel | translate}} </i>";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/PhoneNumberTypeLabel/PhoneNumberTypeLabel.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;